module.exports = __webpack_public_path__ + "img/3.6278dd64.jpg";